export default function ShadowBody() {
  return (
    <span className="mx_MTextBody mx_EventTile_content">
      <div className="mx_EventTile_box loading">
        <span>•</span>
        <span>•</span>
        <span>•</span>
      </div>
    </span>
  )
}
